import Util from "@/Master/Util";
import {store} from "@/app/store";
import {MainState, setMainState} from "@/app/MainSlice";

export const UpdateMainState = (tag:string,updateData: Partial<MainState>)=> {
    if (Util.isLog){
        console.log("updateMainState", tag,updateData)
    }
    store.dispatch(setMainState(updateData));
}
